var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorporateFare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 17.5C2.875 17.5 2.48264 17.3368 2.15625 17.0104C1.82986 16.684 1.66667 16.2917 1.66667 15.8333V4.16667C1.66667 3.70833 1.82986 3.31597 2.15625 2.98958C2.48264 2.66319 2.875 2.5 3.33333 2.5H8.33333C8.79167 2.5 9.18403 2.66319 9.51042 2.98958C9.83681 3.31597 10 3.70833 10 4.16667V5.83333H16.6667C17.125 5.83333 17.5174 5.99653 17.8438 6.32292C18.1701 6.64931 18.3333 7.04167 18.3333 7.5V15.8333C18.3333 16.2917 18.1701 16.684 17.8438 17.0104C17.5174 17.3368 17.125 17.5 16.6667 17.5H3.33333ZM3.33333 15.8333H8.33333V14.1667H3.33333V15.8333ZM3.33333 12.5H8.33333V10.8333H3.33333V12.5ZM3.33333 9.16667H8.33333V7.5H3.33333V9.16667ZM3.33333 5.83333H8.33333V4.16667H3.33333V5.83333ZM10 15.8333H16.6667V7.5H10V15.8333ZM12.5 10.8333C12.2639 10.8333 12.066 10.7535 11.9062 10.5938C11.7465 10.434 11.6667 10.2361 11.6667 10C11.6667 9.76389 11.7465 9.56597 11.9062 9.40625C12.066 9.24653 12.2639 9.16667 12.5 9.16667H14.1667C14.4028 9.16667 14.6007 9.24653 14.7604 9.40625C14.9201 9.56597 15 9.76389 15 10C15 10.2361 14.9201 10.434 14.7604 10.5938C14.6007 10.7535 14.4028 10.8333 14.1667 10.8333H12.5ZM12.5 14.1667C12.2639 14.1667 12.066 14.0868 11.9062 13.9271C11.7465 13.7674 11.6667 13.5694 11.6667 13.3333C11.6667 13.0972 11.7465 12.8993 11.9062 12.7396C12.066 12.5799 12.2639 12.5 12.5 12.5H14.1667C14.4028 12.5 14.6007 12.5799 14.7604 12.7396C14.9201 12.8993 15 13.0972 15 13.3333C15 13.5694 14.9201 13.7674 14.7604 13.9271C14.6007 14.0868 14.4028 14.1667 14.1667 14.1667H12.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateFare);
export default __webpack_public_path__ + "static/media/icon_corporate_fare.b0c6b2795bd438ce4ef9bacf8f30e664.svg";
export { ForwardRef as ReactComponent };